// extracted by mini-css-extract-plugin
export default {"filter":"ProductFilter_filter__AWyLK"};